import Image from 'next/image'
import couponBackground from '@public/image/coupon-background.png'
import couponBlueSection from '@public/image/coupon-blue-section.png'

type SubscriptionCouponCodeProps = {
  amount?: string
  text?: string
  className?: string
}

const SubscriptionCouponCode = ({ amount, text, className = '' }: SubscriptionCouponCodeProps) => {
  return (
    <div className={`relative h-[120px] w-full max-w-[218px] ${className}`}>
      <div className="relative h-full w-full">
        <Image src={couponBackground} alt="Coupon background" fill />

        <div className="absolute right-0 top-0 h-full">
          <Image
            src={couponBlueSection}
            alt="Blue section"
            width={40}
            height={100}
            className="h-full"
          />
        </div>

        <div className="absolute inset-0 flex flex-col justify-between p-[18px] pr-[58px]">
          <div className="w-14 whitespace-pre-wrap font-miSansBold630 text-xs font-[630] uppercase leading-[1.2] text-[#BBBBBD]">
            {text}
          </div>
          <div className="flex flex-row justify-end">
            <div className="flex flex-row items-center text-end font-miSansSemiBold520 text-[47px] text-[#222223]">
              <span className="font-miSansBold630 text-[37px]">$</span>
              <span>{amount}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionCouponCode
